import React, { useState } from "react";
import { Text, Flex, Button, useDisclosure } from "@chakra-ui/react";
import { Tooltip as ChakraTooltip, TooltipProps } from "@chakra-ui/react";
import Icon from "../../Icon";
import { useWeb3React } from "@web3-react/core";
import { injectedConnector, walletConnectConnector } from "../../../connectors/injectedConnector";
import MintModal from "../MintModal";
import Toggle from "../../Toggle";
import { useLiquity } from "../../../Hooks/LiquityContext";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { formatWalletAddress } from "./../../../Utils/string";
import { getNum, format } from "./../../../Utils/number";

const selector = ({ yusdBalance, yetiBalance, YETIPrice }: LiquityStoreState) => ({
  yusdBalance,
  yetiBalance,
  YETIPrice
});

type UserDetailsProps = {
  onChange: any;
};

const UserDetails: React.FC<UserDetailsProps> = ({ onChange }) => {
  const { deactivate, active, error } = useWeb3React<unknown>();
  const { account } = useLiquity();
  const { yusdBalance, yetiBalance, YETIPrice } = useLiquitySelector(selector);
  const userYusdBalance = format(yusdBalance);
  const userYetiBalance = format(yetiBalance);
  const {
    liquity: {
      connection: { addresses }
    }
  } = useLiquity();

  const { isOpen: isMintOpen, onOpen: onMintOpen, onClose: onMintClose } = useDisclosure();

  const [log, setLog] = useState<string[]>([]);
  const addToken = (params: any) => {
    // @ts-ignore
    const func = window.ethereum.request;

    func({ method: "wallet_watchAsset", params }) //@ts-ignore
      .then(() => setLog([...log, "Success, Token added!"]))
      .catch((error: Error) => setLog([...log, `Error: ${error.message}`]));
  };

  const addYusdToken = () => {
    addToken({
      type: "ERC20",
      options: {
        address: addresses["yusdToken"],
        symbol: "YUSD",
        decimals: 18,
        image:
          "https://i.ibb.co/DCL8fhg/yusd-Token.png"
      }
    });
  };

  const addYetiToken = () => {
    addToken({
      type: "ERC20",
      options: {
        address: addresses["yetiToken"],
        symbol: "YETI",
        decimals: 18,
        image:
          "https://i.ibb.co/jL53YjK/yeti-Token.png"
      }
    });
  };

  return (
    <>
      <MintModal isOpen={isMintOpen} onClose={onMintClose} />
      <Flex align="center" direction={["column", null, "row"]}>
        <Flex align="center">
          <ChakraTooltip label={"Add YETI to Metamask"} placement="top">
            <Button variant='link' onClick={addYetiToken}>
              <Icon iconName="YETI" h={6} w={6} mr={2} />
              <Text textStyle="subtitle2" mr={3}>
                {getNum(userYetiBalance)} YETI
              </Text>
            </Button>
          </ChakraTooltip>
          <ChakraTooltip label={"Add YUSD to Metamask"} placement="top">
            <Button variant='link' onClick={addYusdToken}>
              <Icon iconName="YUSD" h={6} w={6} mr={2} />
              <Text textStyle="subtitle2" mr={[0, null, 3]}>
                {getNum(userYusdBalance)} YUSD
              </Text>
            </Button>
          </ChakraTooltip>
          <Text textStyle="walletAddress">{formatWalletAddress(account, 6, 4, 13)}</Text>
          {/* <ChakraTooltip label={"Disconnect Wallet"} placement="top">
            <Button variant='link' onClick={() => {deactivate()}}><Text textStyle="walletAddress">{formatWalletAddress(account, 6, 4, 13)}</Text></Button>
          </ChakraTooltip> */}
          {/* <Button colorScheme="brand" ml={4} width={165}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={"https://techdocs.yeti.finance/"}
              style={{ outline: "none", textDecoration: "none" }}
            >
              Buy $YETI 
            </a>
          </Button> */}
          <Button colorScheme="brand" ml={4} onClick={onMintOpen}>
            Mint
          </Button>
          
          <Flex align="center" h={10} ml={4}>
            <Toggle
              options={[
                { key: "nosnow", value: " ⛅ " },
                { key: "snow", value: " ❄️ " }
              ]}
              size="md"
              onChange={onChange}
            />
          </Flex>
        </Flex>
        <Flex align="center" mt={[6, null, 0]}>
          
        </Flex>
      </Flex>
    </>
  );
};

export default UserDetails;
